module.exports = __webpack_public_path__ + "img/reference50.612e7e21.jpg";